import React from 'react';

const ControlButton = ({children,cssButton}) => {
    const css = `control-button-soa mt-20 ${cssButton}` ;
    return (
        <div className={css}>
            {children}
        </div>
    );
}

export default ControlButton;
